import { gql } from '../../../generated';

const SalesChart = gql(/* GraphQL */ `
  query SalesChart(
    $currency_id: String!
    $gate_group_id: String
    $operation_type: SalesChartOperationType!
    $period: DashboardV2PeriodType!
  ) {
    dashboardWidgetsSalesChartV2(
      currency_id: $currency_id
      gate_group_id: $gate_group_id
      operation_type: $operation_type
      period: $period
    ) {
      data {
        date
        invoice_amount
        withdraw_amount
      }
      y_axis_divisions
    }
  }
`);

export default SalesChart;
